import { Component, Input, EventEmitter, Output, QueryList, ViewChildren, OnInit } from '@angular/core';

import { ConsolidationFilterComponent } from '../consolidation-filter/consolidation-filter.component';
import { ConsolGridOrderBy } from '../../models/consol-grid-order-by.enum';
import { ConsolListFilterRequest } from '../../models/consol-list-filter-request.model';
import { Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-consolidation-filter-panel',
  templateUrl: './consolidation-filter-panel.component.html',
  styleUrls: ['./consolidation-filter-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, ConsolidationFilterComponent],
})

@Injectable({
  providedIn: 'root',
})
export class ConsolidationFilterPanelComponent implements OnInit {
  @Input() public filter: ConsolListFilterRequest;
  @Input() public columns: any;

  @Output() public afterClearFilters: EventEmitter<{}> = new EventEmitter();
  @Output() public updateFilters: EventEmitter<{}> = new EventEmitter();

  @ViewChildren(ConsolidationFilterComponent) public filters: QueryList<ConsolidationFilterComponent>;

  public lastAppliedFilter: ConsolListFilterRequest;

  public recentShipments : string[] = [];
  private readonly STORAGE_KEY = 'cw_recent_shipments';

  public ngOnInit(): void {
    if (this.valueInSession()) {
      this.filter.HouseBillNumber = sessionStorage.getItem('HBL');
      this.filter.MasterBillNumber = sessionStorage.getItem('MBL');
      this.filter.ContainerNumber = sessionStorage.getItem('Container');
      this.filter.CustomerRefNumber = sessionStorage.getItem('CustomerRef');
      this.filter.ConsigneeName = sessionStorage.getItem('ConsigneeName');
      this.filter.ShipmentCode = sessionStorage.getItem('ShipmentCode');
      
    }
    this.initLastAppliedFilter();
    this.loadRecentShipments();


    // const x = document.getElementsByClassName('consolidation-filter');
    // const y = x[0].children[0];
    // for (let i = 0; i < x.length; i++) {
      // x[i].children[0].setAttribute('ng-reflect-model', i.toString());
    // }
    // for (let i = 0; i++; i < x.length) {
    //  const html = x[i].children[0].outerHTML;
    //  if (html.indexOf('Search Master B/L#') != 0) {
    //    // x[i].children[0].
    //  }
    // }
  }

  public onFilterInputChange(value: string, column: ConsolGridOrderBy): void {
    switch (column) {
      case ConsolGridOrderBy.MasterBillNumber:
        this.filter.MasterBillNumber = value;
        break;
      case ConsolGridOrderBy.HouseBillNumber:
        this.filter.HouseBillNumber = value;
        break;
      case ConsolGridOrderBy.ContainerNumber:
        this.filter.ContainerNumber = value;
        break;
      case ConsolGridOrderBy.CustomerRefNumber:
        this.filter.CustomerRefNumber = value;
        break;
      case ConsolGridOrderBy.ConsigneeName:
        this.filter.ConsigneeName = value;
        break;
      case ConsolGridOrderBy.ShipmentCode:
        this.filter.ShipmentCode = value;
        break;
    }
  }

  public clearFilters(): void {
    this.filters.forEach(filter => {
      filter.clearFilter();
    });
    sessionStorage.removeItem('MBL');
    sessionStorage.removeItem('HBL');
    sessionStorage.removeItem('Container');
    sessionStorage.removeItem('CustomerRef');
    sessionStorage.removeItem('ConsigneeName');
    sessionStorage.removeItem('ShipmentCode');
    this.initLastAppliedFilter();

    this.afterClearFilters.emit();
  }

  public isFilterEmpty(): boolean {
    return !this.filter.ContainerNumber && !this.filter.CustomerRefNumber && !this.filter.HouseBillNumber && !this.filter.MasterBillNumber
      && !this.filter.ConsigneeName && !this.filter.ShipmentCode;
  }

  public isFilterChanged(): boolean {
    return this.filter.MasterBillNumber !== this.lastAppliedFilter.MasterBillNumber ||
      this.filter.HouseBillNumber !== this.lastAppliedFilter.HouseBillNumber ||
      this.filter.ContainerNumber !== this.lastAppliedFilter.ContainerNumber ||
      this.filter.CustomerRefNumber !== this.lastAppliedFilter.CustomerRefNumber ||
      this.filter.ConsigneeName !== this.lastAppliedFilter.ConsigneeName ||
      this.filter.ShipmentCode !== this.lastAppliedFilter.ShipmentCode;
  }

 public update(): void {
  this.initLastAppliedFilter();
  sessionStorage.setItem('MBL', this.lastAppliedFilter.MasterBillNumber);
  sessionStorage.setItem('HBL', this.lastAppliedFilter.HouseBillNumber);
  sessionStorage.setItem('Container', this.lastAppliedFilter.ContainerNumber);
  sessionStorage.setItem('CustomerRef', this.lastAppliedFilter.CustomerRefNumber);
  sessionStorage.setItem('ConsigneeName', this.lastAppliedFilter.ConsigneeName);
  sessionStorage.setItem('ShipmentCode', this.lastAppliedFilter.ShipmentCode);

  //  ADD THIS BLOCK HERE: Captures the search item whenever you update filters
  if (this.lastAppliedFilter.ShipmentCode && this.lastAppliedFilter.ShipmentCode.trim()) {
    this.addToRecentShipments(this.lastAppliedFilter.ShipmentCode.trim());
  }

  this.updateFilters.emit();
}

private loadRecentShipments(): void {
  try {
    const data = localStorage.getItem(this.STORAGE_KEY);
    this.recentShipments = data ? JSON.parse(data) : [];
  } catch (e) {
    console.error('Failed reading history tracks from local storage:', e);
  }
}

// Safely logs unique search tokens and drops older records past 4 entries

private addToRecentShipments(shipmentCode: string) : void {
  this.recentShipments = this.recentShipments.filter(code => code !== shipmentCode);
  this.recentShipments.unshift(shipmentCode);

  if (this.recentShipments.length > 4) {
    this.recentShipments.pop();
}
localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.recentShipments));
}

// Handles selection interaction from dropdown panel clicks
   
  public quickSearchShipment(shipmentCode: string): void {
    // 1. Pass data directly to filter models
    this.onFilterInputChange(shipmentCode, ConsolGridOrderBy.ShipmentCode);
    
    // 2. Locate the 6th input box instance inside the ViewChildren QueryList collection
    if (this.filters) {
      const shipmentFilterEl = this.filters.find((_, index) => index === 5);
      if (shipmentFilterEl) {
        // Force sync value directly down to its child input display property field
        (shipmentFilterEl as any).value = shipmentCode;
      }
    }
    
    // 3. Trigger immediate search filtering round trip update
    this.update();
  }
  

  private valueInSession(): boolean {
    return sessionStorage.getItem('MBL') !== null ||
      sessionStorage.getItem('HBL') !== null ||
      sessionStorage.getItem('Container') !== null ||
      sessionStorage.getItem('CustomerRef') !== null ||
      sessionStorage.getItem('ConsigneeName') !== null ||
      sessionStorage.getItem('ShipmentCode') !== null;
  }



  private initLastAppliedFilter(): void {
    this.lastAppliedFilter = {
      ...this.filter,
    };
  }
}
